export const PlayIcon = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M21.6842 43.3684C9.69412 43.3684 0 33.6743 0 21.6842C0 9.69412 9.69412 0 21.6842 0C33.6743 0 43.3684 9.69412 43.3684 21.6842C43.3684 33.6743 33.6743 43.3684 21.6842 43.3684ZM21.6842 2.55108C11.0972 2.55108 2.55108 11.0972 2.55108 21.6842C2.55108 32.2712 11.0972 40.8173 21.6842 40.8173C32.2712 40.8173 40.8173 32.2712 40.8173 21.6842C40.8173 11.0972 32.2712 2.55108 21.6842 2.55108Z"
                fill="currentColor"
            />
            <path
                d="M17.0113 32.0989C16.6779 32.2894 16.2632 32.0487 16.2632 31.6648L16.2632 11.7038C16.2632 11.3198 16.6779 11.0792 17.0113 11.2696L34.4772 21.2501C34.8131 21.4421 34.8131 21.9264 34.4772 22.1184L17.0113 32.0989ZM18.793 15.0793L18.793 28.1646L30.1772 21.5596L18.793 15.0793Z"
                fill="currentColor"
            />
        </svg>
    );
};
